// Admin-only destructive database-level operations.
import { api } from './api.js';

// DROP DATABASE on the given connection. The backend is admin-gated and refuses
// system schemas; the caller must arm this with a type-the-name confirmation.
export async function dropDatabase(connectionId, database) {
  return api.delete(`/api/connections/${connectionId}/databases/${encodeURIComponent(database)}`);
}
